<template>
     <div class="header cent">
      <img class="logo" src="../../static/img/fzlogo@2x.png" alt=""
      >
      <img class="more" @click="open()" src="../../static/img/汉堡包@2x.png" alt="">
      <mt-popup
        v-model="popupVisible"
        :modal= "true"
        position="right">
        <ul class="popupList">
            <img @click="close" src="../../static/img/close@2x@2x.png" alt="">
            <li v-for="(item, i) in navList" :key="i" :class="{ nav_li : active === i }" @click="gonav(item, i)">
                <span> {{item.name}}</span>
                <span> {{item.nameEng}}</span>
                 <span></span>
            </li>
            <!-- <li @click="$router.push({path:'/Homes'})" >
                <span>首页</span>
                <span>Home</span>
                <span></span>
            </li>
             <li @click="$router.push({path:'/group'})">
                <span>集团概况</span>
                <span>Group overview</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/industrial'})">
                <span>产业链及子公司</span>
                <span>Industrial Chain and Subsidiaries</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/products'})">
                <span>产品及下载</span>
                <span>Products and DownLoads</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/culture'})">
                <span>企业文化</span>
                <span>Corporate Culture</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/parnter'})">
                <span>合作伙伴</span>
                <span>Cooperative Partner</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/contact'})">
                <span>联系我们</span>
                <span>Contact Us</span>
                 <span></span>
            </li>
            <li @click="$router.push({path:'/disclosure'})">
                <span>信息披露</span>
                <span>Information Disclosure</span>
            </li> -->
        </ul>
        </mt-popup>
    </div>
</template>

<script>
export default {
  data () {
    return {
      popupVisible: false,
      active: 0,
      navList:[
          { 
            name: '首页',
            nameEng: 'Home',
            path: '/Homes'
          },
          { 
            name: '集团概况',
            nameEng: 'Group overview',
            path: '/group'
          },
          { 
            name: '产业链及子公司',
            nameEng: 'Industrial Chain and Subsidiaries',
            path: '/industrial'
          },
          { 
            name: '产品及下载',
            nameEng: 'Products and DownLoads',
            path: '/products'
          },
          { 
            name: '企业文化',
            nameEng: 'Corporate Culture',
            path: '/culture'
          },
          { 
            name: '合作伙伴',
            nameEng: 'Cooperative Partner',
            path: '/parnter'
          },
          { 
            name: '联系我们',
            nameEng: 'Contact Us',
            path: '/contact'
          },
          { 
            name: '信息披露',
            nameEng: 'Information Disclosure',
            path: '/disclosure'
          },

         
      ]
     
              
    }
  },
   mounted() {
        this.active = sessionStorage.getItem('pages') - 0
    },
  methods: {
    open () {
      this.popupVisible = true
    },
    close () {
      this.popupVisible = false
    },
     gonav(item, i){
            sessionStorage.setItem('pages', i)
            this.$router.push({ path: item.path})
            this.active = sessionStorage.getItem('pages') - 0
        }
  },

}
</script>

<style lang="scss" scoped>
.cent{
  margin: 0 auto;
  width: 92%;
  }
.header {
  height: 0.88rem;
  line-height: 0.88rem;
  display: flex;
  justify-content: space-between;
  .logo {
    margin-top: 0.12rem;
    width: 1.48rem;
    height: 0.64rem;
  }
  .more {
    margin-top: 0.25rem;
    width: 0.36rem;
    height: 0.29rem;
  }
}
.mint-popup-right{
  width: 100%;
  height: 100%;
  overflow: auto;
  .popupList{
    padding-left: 22%;
    position: relative;
    overflow: auto;
    img{
      width: .28rem;
      height: .28rem;
      display: inline-block;
      position:absolute;
      top: .2rem;
      right: 0.4rem;
    }
    li{
      height: 1.6rem;
      line-height: 1.6rem;
      position: relative;
      span{
         padding-top: .3rem;
        color: #323232;
        display: block;
        height: .45rem;
        font-size: .32rem;
        line-height: .45rem;
      }
      span:nth-child(1){
      font-weight: 700;
      }
      span:nth-child(2){
        color: #6a6a6a;
         font-size: .22rem;
      }
      span:nth-child(3){
          height: .1rem;
          border-bottom: 1px solid #0250a2;
          position: absolute;
          bottom: .05rem;
          right: .1rem;
          width: 90%;
      }
    }
    .nav_li {
          color: red;
        }
  }

}

</style>



// WEBPACK FOOTER //
// src/components/Header.vue